import React from 'react';
import styled, { css } from 'styled-components';

type Layout = 'columns';
type Size = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
	heading?: string;
	subheading?: string;
	layout?: Layout;
}

const layouts = {
	columns: css`
		display: grid;
		grid-auto-flow: column;
		grid-gap: ${({ theme }) => theme.spacing.xxl};
		margin-top: 24px;
	`
};

const Heading = styled.h2`
	${({ theme }) => theme.typography.heading4};
	margin: 0 0 48px;
	color: ${({ theme }) => theme.palette.primary.main};
	text-transform: uppercase;
	text-align: center;
`;

const Subheading = styled.h3``;

const Content = styled.div<{ layout?: Layout }>`
	${({ layout }) => layout ? layouts[layout] : ''}
`;

export const Section = ({ heading, subheading, layout, children, ...props }: Props) =>
	<section {...props} data-testid="section">
		{(heading || subheading) &&
			<header>
				{heading && <Heading>{heading}</Heading>}
				{subheading && <Subheading>{subheading}</Subheading>}
			</header>
		}
		<Content layout={layout}>
			{children}
		</Content>
	</section>